import { FormattedMessage } from 'components/shared/Intl';
import { FC } from 'react';

export interface ButtonProps {
  onClick: () => void;
}

export const AddRowButton: FC<ButtonProps> = ({ onClick }) => (
  <a className="btn btn-sm btn-flat-primary btn-icon-start p-2" onClick={onClick} data-e2e="add-deal-split">
    <i className="icon">add</i>
    <FormattedMessage id="form.DealSplit.addCustodian" />
  </a>
);
